import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import { EmptyState, Icons } from "construct-ui";
import chartModel from "../../../models/charts/chart.model";
import languageModel from "../../../models/language.model";
import 'CssFolder/chart.scss';

export default function NewModelDisplayPieChartComponent() {

    let chart;
    let chartId = 'piechart_new_model_display';
    let root;
    let series;
    let legend;
    let data = null;
    let dataLoaded = false;
    let colorSet; // ["#01B3E3", "#B5B5B5", ... ]
    let DEFAULT_COLOR_SET = [
        am5.color(0x1428A0), // Blue
        am5.color(0xFE4335), // Orange
        am5.color(0xFEB545), // Yellow mustard
        am5.color(0x01B3E3), // Light blue
        am5.color(0x97D654), // Green
        am5.color(0x001737), // Black
        am5.color(0xB5B5B5), // Grey
    ]

    function initChart(_data) {
        createChart();
        createSeries();
        createLegend();

        loadData(_data);

        // Animate on when appear
        series.appear(1000, 100);
    }

    function createChart() {
        root = am5.Root.new(chartId);

        root.setThemes([
            am5themes_Responsive.new(root),
            am5themes_Animated.new(root)
        ]);

        chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                radius: am5.percent(80),
                layout: root.horizontalLayout,
            })
        );
    }

    function createSeries() {
        series = chart.series.push(am5percent.PieSeries.new(root, {
            alignLabels: true,
            calculateAggregates: true,
            valueField: "value",
            categoryField: "key",
            legendLabelText: "{key}:",
            legendValueText: "[fontSize: 12px;bold]{value}%[/]",
            tooltip: am5.Tooltip.new(root, {
                labelText: "{key}: {value}%"
            })
        }));

        if (colorSet?.length > 0) {
            series.get("colors").set("colors", colorSet);
        } else {
            series.get("colors").set("colors", DEFAULT_COLOR_SET);
        }

        series.slices.template.setAll({
            strokeWidth: 3,
            stroke: am5.color(0xFFFFFF)
        });

        series.labels.template.setAll({
            radius: 0,
            fontSize: 10,
            textAlign: "right",
            text: "{key}:\n[bold]{value}%[/]",
        });

        series.slices.template.adapters.add("fill", function (fill, target) {
            return series.get("colors").getIndex(series.dataItems.indexOf(target.dataItem));
        });
    }

    function loadData(_data) {
        _data ??= [];

        if (data === _data) {
            return;
        }

        data = _data;
        dataLoaded = true;

        // to show / hide series
        if (_data.length > 0) {
            series.show();
        } else {
            series.hide();
        }

        series.data.setAll(_data);

        legend.data.setAll(_data.length > 0 ? series.dataItems : []);
    }

    function createLegend() {
        legend = chart.children.push(am5.Legend.new(root, {
            centerY: am5.p50,
            y: am5.p50,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            layout: root.verticalLayout,
        }));

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });
    }

    return {
        oninit: function (vnode) {
            chartId += chartModel.generateID();
            colorSet = vnode.attrs.colorSet;
        },
        oncreate: function (vnode) {
            if (vnode.attrs.data) {
                initChart(vnode.attrs.data);
            }
        },
        onupdate: function (vnode) {
            if (!dataLoaded) {
                if (vnode.attrs.data) {
                    initChart(vnode.attrs.data);
                }
            } else {
                loadData(vnode.attrs.data);
            }
        },
        view: function (vnode) {
            return [
                vnode.attrs.title &&
                m('.fw-bold.text-center', vnode.attrs.title),
                m('.chart', {
                    id: chartId,
                    style: 'min-width: 320px',
                },
                    !vnode.attrs.data &&
                    m(EmptyState, {
                        icon: Icons.PIE_CHART,
                        content: languageModel.getText("LT00000317", "No results found"),
                        fill: true,
                        style: 'color: var(--is-inactive-gray)',
                    })
                )
            ]
        }
    }
}
